module.exports = __webpack_public_path__ + "img/sykc.a1d3ca0d.png";